@import 'styles/variables';

.root {
  font-size: 12px;
  color: var(--dark-60);
}

.link {
  color: var(--blue-50);
}
